// src/lib/questionsBoot.js
// Odbiór zapytania o pytania wystartowanego jeszcze przed uruchomieniem Reacta.
//
// Skrypt w public/index.html (window.__QUESTIONS_BOOT) wysyła POST od razu
// po sparsowaniu HTML-a, równolegle z pobieraniem bundle'a. Tutaj tylko
// odbieramy gotowy Promise - i tylko wtedy, gdy dotyczy właściwego trybu.

/**
 * Zwraca Promise z pytaniami, jeśli wstępne zapytanie pasuje do trybu
 * (demo vs pełny dostęp). Wynik można odebrać tylko raz - kolejne wejścia
 * do testu mają dostać świeży zestaw pytań, a nie ten sam z pamięci.
 */
export const takePrefetchedQuestions = demo => {
  if (typeof window === 'undefined') return null;

  const boot = window.__QUESTIONS_BOOT;
  if (!boot || !boot.promise) return null;
  if (boot.demo !== demo) return null;

  window.__QUESTIONS_BOOT = null;
  return boot.promise;
};
